<template>
    <div class="current">
        <div class="current__label">{{ label }}</div>
        <div class="current__value">
            {{ currentValue }}
        </div>
    </div>
</template>
<script>
import i18n from '@/i18n'
import { getQuadrantTitle, getAxisWithValue } from '@/views/n-box/utils'
export default {
    props: {
        calibrationType: {
            type: String,
            required: true,
        },
        value: {
            type: Object,
            required: true,
        },
    },
    computed: {
        label() {
            return this.calibrationType == 'score'
                ? i18n.t('nBox.currentScore')
                : i18n.t('nBox.currentQuadrant')
        },
        currentValue() {
            return this.calibrationType == 'score'
                ? this.currentScores
                : this.currentQuadrant
        },
        currentQuadrant() {
            return getQuadrantTitle(this.value.quadrant)
        },
        currentScores() {
            return getAxisWithValue(this.value.x, this.value.y)
        },
    },
}
</script>
<style lang="scss" scoped>
.current {
    color: #828282;
}

.current__label {
    margin-bottom: 7px;
}

.current__value {
    padding: 6px 10px 6px 10px;
    text-align: center;
    background-color: #e9e9e9;
    border: solid 1px #828282;
    border-radius: 3px;
}
</style>
